import React from 'react';
import styles from './generic-small-card.module.css';
import { GenericSmallCard as GenericSmallCardProp } from '../../typescript/component';
import { getCachedAsset } from '../../helper/utils';

export default function GenericSmallCard({ small_card }: { small_card: GenericSmallCardProp }) {
  return (
    <div className={styles.genericSmallCard}>
      <div className={styles.environmentalWrapper}>
        <img
          className={styles.environmentalIcon}
          loading="lazy"
          alt={small_card?.icon?.title}
          src={getCachedAsset(small_card?.icon?.url, {width: 1200, quality: 75})}
        />
      </div>
      <h3 className={styles.titleWrapper}>
        <a className={styles.title}>{small_card?.title}</a>
      </h3>
      <div className={styles.description}>{small_card?.description}</div>
    </div>
  );
}
